/* Directive.js */

'use strict';
const _ = require('lodash');

module.exports = {
  /**
   * Get the settings object from the scope
   * @param $scope {$scope} The angular scope object
   * @param settingsName {string} A lodash path property string representing the property path beneath the scope.
   * @returns {*}
   */
  getSettingsFromScope: function ($scope, settingsName) {
    let scopeSettingsObj = _.get($scope, settingsName);
    //If there is NOT a settings object on this scope look for it on the parent
    if (!scopeSettingsObj) {
      scopeSettingsObj = _.get($scope.$parent, settingsName);
    }
    return scopeSettingsObj;
  },

  /**
   * Attach the api object to the scope using a dot notation apiName.
   * If this apiName isn't already in the scope it will be created
   * in the parent scope.
   * @param $scope {$scope} The angular scope object
   * @param apiName {string} A lodash path property string representing the property path beneath the scope.
   * @param api {Object} The api thing to be put on the scope object.
   */
  attachApiToScope: function ($scope, apiName, api) {
    let scopeApiObj;
    //If there is NOT an api object on this scope look for it on the parent
    if (!_.has($scope, apiName)) {
      //If there is NOT an api object on the parent create it
      if (!_.has($scope.$parent, apiName)) {
        _.set($scope.$parent, apiName, {});
      }
      scopeApiObj = _.get($scope.$parent, apiName);
    } else {
      scopeApiObj = _.get($scope, apiName);
    }

    scopeApiObj.__proto__ = api.__proto__;
    _.extend(scopeApiObj, api);
    return scopeApiObj;
  },
};
